import type { components } from '../../api/generated/schema'

type Schema = components['schemas']

/**
 * Display labels for a few domain enums.
 *
 * These are **presentation only** — the values themselves always come from the
 * server (`/reference/enums`), and nothing here decides behaviour. They exist
 * because the enum member names are identifiers, not prose: a power-level radio
 * reading "CHESTDEEP" is worse than one reading "Chest-Deep", and the Blazor app
 * has carried the same table since the beginning.
 *
 * Anything unknown falls through to the raw name, so a value added server-side
 * shows up as itself rather than disappearing.
 */

const SKILL_POOLS: Record<string, string> = {
  FeetInTheWater: 'Feet in the Water',
  UpToYourWaist: 'Up to Your Waist',
  ChestDeep: 'Chest-Deep',
  Submerged: 'Submerged',
}

const CHARACTER_TYPES: Record<string, string> = {
  PC: 'PC — Player Character',
  GM_PC: 'GM-PC — Game Master’s Character',
  NPC: 'NPC — Non-Player Character',
  Temp: 'Temp — Temporary Character',
}

const CLASS_TYPES: Record<string, string> = {
  Mortal: 'Mortal — no supernatural abilities',
  SpellCaster: 'Spell Caster — uses magic',
  Shapeshifter: 'Shapeshifter — has more than one shape',
  Vampire: 'Vampire — sustained by feeding',
}

export const skillPoolLabel = (value: string): string => SKILL_POOLS[value] ?? value
export const characterTypeLabel = (value: string): string => CHARACTER_TYPES[value] ?? value
export const classTypeLabel = (value: string): string => CLASS_TYPES[value] ?? value

export const SKILL_POOL_ORDER: Array<Schema['SkillPoolOption']> = [
  'FeetInTheWater',
  'UpToYourWaist',
  'ChestDeep',
  'Submerged',
]

export const CHARACTER_TYPE_ORDER: Array<Schema['CharacterType']> = ['PC', 'GM_PC', 'NPC', 'Temp']

export const CLASS_TYPE_ORDER: Array<Schema['CharacterClassType']> = [
  'Mortal',
  'SpellCaster',
  'Shapeshifter',
  'Vampire',
]
